const BASE_PATH = '/'
const LOGIN = '/login'
const SIGN_UP = '/signup'
const ONBOARDING = '/onboarding'
const FORGOT_PASSWORD = '/forgot-password'
const LINK_SENT = '/check-your-email/:messageId'
const VERIFICATION = '/change-password/:token'
const RESET_PASSWORD = '/reset-password'
const USER_PROFILE = '/user-profile'
const LOGOUT = '/logout'
const USERS = '/users'
const EDIT_USER = '/users/edit/:userId'
const DASHBOARD = '/dashboard'
const CREATE_MATERIAL = '/material/create'
const EDIT_MATERIAL = '/material/edit/:materialId'
const LIST_MATERIAL = '/material/list'
const PRODUCTS = '/products/list'
const ADD_NEW_PRODUCT = '/products/add'
const CUSTOMIZE_PRODUCT = '/products/customize/:productId'
const SHOPPER_PREVIEW_PRODUCT = '/p/:previewId'
const EDIT_PRODUCT = '/products/edit/:productId'
const HELP_GUIDES = '/help'
const CUSTOMIZE_THEME = '/customize-theme'

// Student book access routes
// New format: /b/:businessSlug/:bookSlug/:category (supports multi-book access)
// Legacy format: /:book/:category (backwards compatible for existing QR codes)
const AR_PLAYBOOK_V2 = '/b/:businessSlug/:book'
const AR_PLAYBOOK_CATEGORY_V2 = '/b/:businessSlug/:book/:category'
const AR_PLAYBOOK = '/:book' // Legacy - kept for backwards compatibility
const AR_PLAYBOOK_CATEGORY = '/:book/:category' // Legacy - kept for backwards compatibility

const AR_PLAYBOOK_ADMIN_BASE = '/admin' // Base path for all admin routes
const AR_PLAYBOOK_ADMIN_LOGIN = '/admin/login'
const AR_PLAYBOOK_ADMIN_SIGN_UP = '/admin/signup'
const AR_PLAYBOOK_ADMIN_FORGOT_PASSWORD = '/admin/forgot-password'
const AR_PLAYBOOK_ADMIN_RESET_PASSWORD = '/admin/reset-password/:token'
const AR_PLAYBOOK_ADMIN_DASHBOARD = '/admin/dashboard'
const AR_PLAYBOOK_ADMIN_BOOKS = '/admin/books'
const AR_PLAYBOOK_ADMIN_ADD_BOOK = '/admin/books/add'
const AR_PLAYBOOK_ADMIN_EDIT_BOOK = '/admin/books/edit/:bookId'
const AR_PLAYBOOK_ADMIN_PROFILE = '/admin/profile'
const AR_PLAYBOOK_ADMIN_LICENSES = '/admin/licenses'
const AR_PLAYBOOK_SUPER_ADMIN = '/admin/superadmin'
const AR_PLAYBOOK_LICENSE_ACTIVATE = '/license/:licenseKey'
const AR_PLAYBOOK_UNAUTHORIZED = '/unauthorized' // Student unauthorized page (not /admin)
const AR_PLAYBOOK_MY_BOOKS = '/my-books' // Student book switcher page
const TEXT_TO_SPEECH = '/text-to-speech'
const MODEL_ASSET_UPLOAD = '/model-asset-upload'

// Marketplace routes (public)
const MARKETPLACE = '/marketplace'
const MARKETPLACE_BOOK = '/marketplace/book/:bookId'
const MARKETPLACE_PURCHASE = '/marketplace/book/:bookId/purchase'
const MARKETPLACE_SUCCESS = '/marketplace/purchase/:purchaseId/success'

const routes = {
    BASE_PATH,
    LOGIN,
    SIGN_UP,
    ONBOARDING,
    FORGOT_PASSWORD,
    LINK_SENT,
    VERIFICATION,
    RESET_PASSWORD,
    USER_PROFILE,
    LOGOUT,
    USERS,
    EDIT_USER,
    DASHBOARD,
    CREATE_MATERIAL,
    EDIT_MATERIAL,
    LIST_MATERIAL,
    PRODUCTS,
    ADD_NEW_PRODUCT,
    CUSTOMIZE_PRODUCT,
    SHOPPER_PREVIEW_PRODUCT,
    EDIT_PRODUCT,
    HELP_GUIDES,
    CUSTOMIZE_THEME,
    AR_PLAYBOOK,
    AR_PLAYBOOK_CATEGORY,
    AR_PLAYBOOK_V2,
    AR_PLAYBOOK_CATEGORY_V2,
    AR_PLAYBOOK_ADMIN_BASE,
    AR_PLAYBOOK_ADMIN_LOGIN,
    AR_PLAYBOOK_ADMIN_SIGN_UP,
    AR_PLAYBOOK_ADMIN_FORGOT_PASSWORD,
    AR_PLAYBOOK_ADMIN_RESET_PASSWORD,
    AR_PLAYBOOK_ADMIN_DASHBOARD,
    AR_PLAYBOOK_ADMIN_BOOKS,
    AR_PLAYBOOK_ADMIN_ADD_BOOK,
    AR_PLAYBOOK_ADMIN_EDIT_BOOK,
    AR_PLAYBOOK_ADMIN_PROFILE,
    AR_PLAYBOOK_ADMIN_LICENSES,
    AR_PLAYBOOK_LICENSE_ACTIVATE,
    AR_PLAYBOOK_UNAUTHORIZED,
    AR_PLAYBOOK_MY_BOOKS,
    AR_PLAYBOOK_SUPER_ADMIN,
    TEXT_TO_SPEECH,
    MODEL_ASSET_UPLOAD,
    MARKETPLACE,
    MARKETPLACE_BOOK,
    MARKETPLACE_PURCHASE,
    MARKETPLACE_SUCCESS,
}

// Named export for destructuring
export { routes as ROUTES }

export default routes
